// CAD Projects Data — Referenzen (Stahlbau, Metallbau, Rohrleitungsplanung)

// ARA FLOS - Geländer Treppen Leiter und Gitteroste
import araFlosGelander1 from '../assets/CAD_Pictures/ARA FLOS -  Geländer Treppen Leiter und Gitteroste/1.png';
import araFlosGelander2 from '../assets/CAD_Pictures/ARA FLOS -  Geländer Treppen Leiter und Gitteroste/2.png';

// ARA FLOS Geländer und Stege
import araFlosStege1 from '../assets/CAD_Pictures/ARA FLOS Geländer und Stege/1.png';
import araFlosStege2 from '../assets/CAD_Pictures/ARA FLOS Geländer und Stege/2.png';

// Ara Flos Gitterrostabdeckung
import araFlosGitter1 from '../assets/CAD_Pictures/Ara Flos Gitterrostabdeckung/1.png';
import araFlosGitter2 from '../assets/CAD_Pictures/Ara Flos Gitterrostabdeckung/2.png';

// Ara Reinach ROHR 3D und ISO
import araReinach1 from '../assets/CAD_Pictures/Ara Reinach ROHR 3D und ISO sehr gut zum posten/1.jpg';
import araReinach2 from '../assets/CAD_Pictures/Ara Reinach ROHR 3D und ISO sehr gut zum posten/2.jpg';
import araReinach3 from '../assets/CAD_Pictures/Ara Reinach ROHR 3D und ISO sehr gut zum posten/3.jpg';
import araReinach4 from '../assets/CAD_Pictures/Ara Reinach ROHR 3D und ISO sehr gut zum posten/4.png';
import araReinach5 from '../assets/CAD_Pictures/Ara Reinach ROHR 3D und ISO sehr gut zum posten/5.png';
import araReinach6 from '../assets/CAD_Pictures/Ara Reinach ROHR 3D und ISO sehr gut zum posten/6.png';

// Aussentreppe Glarnerland
import glarnerland1 from '../assets/CAD_Pictures/Aussentreppe Glarnerland (Posted)/1.jpg';
import glarnerland2 from '../assets/CAD_Pictures/Aussentreppe Glarnerland (Posted)/2.jpg';

// Balkon Goldach
import goldach1 from '../assets/CAD_Pictures/BALKON GOLDACH (Posted)/1.png';
import goldach2 from '../assets/CAD_Pictures/BALKON GOLDACH (Posted)/2.png';
import goldach3 from '../assets/CAD_Pictures/BALKON GOLDACH (Posted)/3.jpg';

// Basel Phase 1
import baselPhase1 from '../assets/CAD_Pictures/BASEL PHASE 1/1.jpg';
import baselPhase2 from '../assets/CAD_Pictures/BASEL PHASE 1/2.jpg';
import baselPhase3 from '../assets/CAD_Pictures/BASEL PHASE 1/3.jpg';
import baselPhase4 from '../assets/CAD_Pictures/BASEL PHASE 1/4.jpg';
import baselPhase5 from '../assets/CAD_Pictures/BASEL PHASE 1/5.jpg';

// Basel UESS
import baselUess1 from '../assets/CAD_Pictures/Basel UESS (posted)/1.jpg';
import baselUess2 from '../assets/CAD_Pictures/Basel UESS (posted)/2.jpg';

// Brauchwasserpumpwerk Basel
import brauchwasser1 from '../assets/CAD_Pictures/Brauchwasserpumpwerk Basel (posted)/1.jpg';
import brauchwasser2 from '../assets/CAD_Pictures/Brauchwasserpumpwerk Basel (posted)/2.png';

// Glattbrug Edelstahlwanne
import glattbrug1 from '../assets/CAD_Pictures/Glattbrug Edelstahlwanne/1.png';
import glattbrug2 from '../assets/CAD_Pictures/Glattbrug Edelstahlwanne/2.png';
import glattbrug3 from '../assets/CAD_Pictures/Glattbrug Edelstahlwanne/3.png';

// Handwaschtrog
import handwasch1 from '../assets/CAD_Pictures/Handwaschtrog (posted)/1.png';
import handwasch2 from '../assets/CAD_Pictures/Handwaschtrog (posted)/2.png';
import handwasch3 from '../assets/CAD_Pictures/Handwaschtrog (posted)/3.png';

// Ipsach Konstruktion
import ipsach1 from '../assets/CAD_Pictures/IPSACH KONSTRUKTION/1.png';
import ipsach2 from '../assets/CAD_Pictures/IPSACH KONSTRUKTION/2.png';
import ipsach3 from '../assets/CAD_Pictures/IPSACH KONSTRUKTION/3.jpg';

// Isometrie
import isometrie1 from '../assets/CAD_Pictures/Isometrie (Posted)/1.png';

// Liftkabine
import liftkabine1 from '../assets/CAD_Pictures/LIFTKABINE (Posted)/1.png';
import liftkabine2 from '../assets/CAD_Pictures/LIFTKABINE (Posted)/2.png';
import liftkabine3 from '../assets/CAD_Pictures/LIFTKABINE (Posted)/3.png';
import liftkabine4 from '../assets/CAD_Pictures/LIFTKABINE (Posted)/4.png';

// Lugano Podest
import luganoPodest1 from '../assets/CAD_Pictures/LUGANO PODEST/1.png';
import luganoPodest2 from '../assets/CAD_Pictures/LUGANO PODEST/2.png';
import luganoPodest3 from '../assets/CAD_Pictures/LUGANO PODEST/3.png';

// Lugano Rohr
import luganoRohr1 from '../assets/CAD_Pictures/Lugano ROhr (Posted)/1.png';
import luganoRohr2 from '../assets/CAD_Pictures/Lugano ROhr (Posted)/2.jpg';

// Märstetten Podest
import marstetten1 from '../assets/CAD_Pictures/Märstetten Podest (Posted)/1.jpg';

// Möhlin CAD
import mohlinCad1 from '../assets/CAD_Pictures/Möhlin (Posted)/1.jpg';
import mohlinCad2 from '../assets/CAD_Pictures/Möhlin (Posted)/2.jpg';
import mohlinCad3 from '../assets/CAD_Pictures/Möhlin (Posted)/3.PNG';
import mohlinCad4 from '../assets/CAD_Pictures/Möhlin (Posted)/4.jpg';
import mohlinCad5 from '../assets/CAD_Pictures/Möhlin (Posted)/5.PNG';
import mohlinCad6 from '../assets/CAD_Pictures/Möhlin (Posted)/6.jpg';
import mohlinCad7 from '../assets/CAD_Pictures/Möhlin (Posted)/7.jpg';
import mohlinCad8 from '../assets/CAD_Pictures/Möhlin (Posted)/8.jpg';
import mohlinCad9 from '../assets/CAD_Pictures/Möhlin (Posted)/9.jpg';
import mohlinCad10 from '../assets/CAD_Pictures/Möhlin (Posted)/10.jpg';

// Niederglatt Rohr
import niederglatt1 from '../assets/CAD_Pictures/Niederglatt Rohr (Posted)/1.jpg';
import niederglatt2 from '../assets/CAD_Pictures/Niederglatt Rohr (Posted)/2.jpg';

// Patientenschrank
import patient1 from '../assets/CAD_Pictures/Patientenschrank/1.png';
import patient2 from '../assets/CAD_Pictures/Patientenschrank/2.png';

// Podest Aadorf
import aadorf1 from '../assets/CAD_Pictures/Podest Aadorf (Posted)/1.jpg';

// Rapperswil Jona Podest
import rapJona1 from '../assets/CAD_Pictures/Rapperswil Jona Podest (Posted)/3D Modell.jpg';
import rapJona2 from '../assets/CAD_Pictures/Rapperswil Jona Podest (Posted)/2d.jpg';
import rapJona3 from '../assets/CAD_Pictures/Rapperswil Jona Podest (Posted)/MIXED.jpg';

// RAP JONA SCHNECKE
import rapSchnecke1 from '../assets/CAD_Pictures/RAP JONA SCHNECKE (posted 060324)/Screenshot_1.jpg';
import rapSchnecke2 from '../assets/CAD_Pictures/RAP JONA SCHNECKE (posted 060324)/Screenshot_2.jpg';

// Real Baustelle
import baustelle1 from '../assets/CAD_Pictures/real_baustelle/1.jpg';
import baustelle3 from '../assets/CAD_Pictures/real_baustelle/3.jpg';
import baustelle4 from '../assets/CAD_Pictures/real_baustelle/4.jpg';
import baustelle5 from '../assets/CAD_Pictures/real_baustelle/5.jpg';
import baustelle6 from '../assets/CAD_Pictures/real_baustelle/6.jpg';

// Rohr Werdhölzli
import rohrWerd1 from '../assets/CAD_Pictures/Rohr Werdhölzli (Posted)/WH 10.jpg';
import rohrWerd2 from '../assets/CAD_Pictures/Rohr Werdhölzli (Posted)/WH 10.1.jpg';
import rohrWerd3 from '../assets/CAD_Pictures/Rohr Werdhölzli (Posted)/WH 12.jpg';

// Runde Kunstgeländer
import kunstgelander1 from '../assets/CAD_Pictures/Runde Kunstgeländer (Posted)/1.jpg';
import kunstgelander2 from '../assets/CAD_Pictures/Runde Kunstgeländer (Posted)/2.png';
import kunstgelander3 from '../assets/CAD_Pictures/Runde Kunstgeländer (Posted)/Screenshot_3.jpg';
import kunstgelander4 from '../assets/CAD_Pictures/Runde Kunstgeländer (Posted)/3.jpg';

// Saugkanal
import saugkanal1 from '../assets/CAD_Pictures/SAUGKANAL/Screenshot_1.png';
import saugkanal2 from '../assets/CAD_Pictures/SAUGKANAL/Screenshot_2.png';
import saugkanal3 from '../assets/CAD_Pictures/SAUGKANAL/Screenshot_3.png';

// Schänau Podest mit Abkantblech
import schanauPodest1 from '../assets/CAD_Pictures/SCHÄNAU PODEST MIT ABKANTBLECH/1.png';
import schanauPodest2 from '../assets/CAD_Pictures/SCHÄNAU PODEST MIT ABKANTBLECH/2.png';
import schanauPodest3 from '../assets/CAD_Pictures/SCHÄNAU PODEST MIT ABKANTBLECH/3.jpg';

// Schönau Pumpensumpf Podest
import schonauPumpe1 from '../assets/CAD_Pictures/SCHÖNAU PUMPENSUMF PODEST (poster 1903)/Screenshot_1.png';
import schonauPumpe2 from '../assets/CAD_Pictures/SCHÖNAU PUMPENSUMF PODEST (poster 1903)/Screenshot_2.png';
import schonauPumpe3 from '../assets/CAD_Pictures/SCHÖNAU PUMPENSUMF PODEST (poster 1903)/Screenshot_3.png';
import schonauPumpe4 from '../assets/CAD_Pictures/SCHÖNAU PUMPENSUMF PODEST (poster 1903)/Screenshot_4.png';
import schonauPumpe5 from '../assets/CAD_Pictures/SCHÖNAU PUMPENSUMF PODEST (poster 1903)/Screenshot_5.png';

// Schönau Treppenabgang
import schonauTreppeAb1 from '../assets/CAD_Pictures/SCHÖNAU TREPPENABGANG/1.png';
import schonauTreppeAb2 from '../assets/CAD_Pictures/SCHÖNAU TREPPENABGANG/2.png';

// Schönau Treppenaufgang mit Podest
import schonauTreppeAuf1 from '../assets/CAD_Pictures/SCHÖNAU TREPPENAUFGANG MIT PODEST/1.png';
import schonauTreppeAuf2 from '../assets/CAD_Pictures/SCHÖNAU TREPPENAUFGANG MIT PODEST/2.png';
import schonauTreppeAuf3 from '../assets/CAD_Pictures/SCHÖNAU TREPPENAUFGANG MIT PODEST/Screenshot_1.png';

// Staketengeländer Langnau
import langnau1 from '../assets/CAD_Pictures/Staketengeländer Langnau (Posted)/1.jpg';
import langnau2 from '../assets/CAD_Pictures/Staketengeländer Langnau (Posted)/2.jpg';
import langnau3 from '../assets/CAD_Pictures/Staketengeländer Langnau (Posted)/3.jpg';
import langnau4 from '../assets/CAD_Pictures/Staketengeländer Langnau (Posted)/4.jpg';

// Vordach Amriswil
import vordach1 from '../assets/CAD_Pictures/Vordach Amriswi/1.png';
import vordach2 from '../assets/CAD_Pictures/Vordach Amriswi/VA2.jpg';

// Werdhölzli Ebene 123
import werdEbene1 from '../assets/CAD_Pictures/WERDHÖLZLI EBENE 123/1.png';
import werdEbene2 from '../assets/CAD_Pictures/WERDHÖLZLI EBENE 123/2.png';
import werdEbene3 from '../assets/CAD_Pictures/WERDHÖLZLI EBENE 123/3.png';
import werdEbene4 from '../assets/CAD_Pictures/WERDHÖLZLI EBENE 123/4.png';
import werdEbene5 from '../assets/CAD_Pictures/WERDHÖLZLI EBENE 123/5.png';
import werdEbene6 from '../assets/CAD_Pictures/WERDHÖLZLI EBENE 123/6.png';

// Werdhölzli Geländer und Podest Schaumfalle
import werdSchaum1 from '../assets/CAD_Pictures/WERDHÖLZLI GELÄNDER UND PODEST SCHAUMFALLE (posted 30Apr 24)/1.png';
import werdSchaum2 from '../assets/CAD_Pictures/WERDHÖLZLI GELÄNDER UND PODEST SCHAUMFALLE (posted 30Apr 24)/2.png';
import werdSchaum3 from '../assets/CAD_Pictures/WERDHÖLZLI GELÄNDER UND PODEST SCHAUMFALLE (posted 30Apr 24)/3.png';

// Werdhölzli runder Podest
import werdRund1 from '../assets/CAD_Pictures/Werdhölzli runder Podest (Posted)/1.jpg';
import werdRund2 from '../assets/CAD_Pictures/Werdhölzli runder Podest (Posted)/2.jpg';
import werdRund3 from '../assets/CAD_Pictures/Werdhölzli runder Podest (Posted)/3.jpg';
import werdRund4 from '../assets/CAD_Pictures/Werdhölzli runder Podest (Posted)/4.jpg';

// Werdhölzli Treppe an bestehendem Steg
import werdTreppe1 from '../assets/CAD_Pictures/WERDHÖLZLI TREPPE AN BESTEHENDEM STEG/1.png';
import werdTreppe2 from '../assets/CAD_Pictures/WERDHÖLZLI TREPPE AN BESTEHENDEM STEG/2.png';
import werdTreppe3 from '../assets/CAD_Pictures/WERDHÖLZLI TREPPE AN BESTEHENDEM STEG/3.png';

export const cadProjectsData = [
  {
    id: 1,
    title: 'ARA FLOS – GELÄNDER, TREPPEN & GITTEROSTE',
    location: 'Schweiz',
    type: 'Stahlbau',
    mainImage: araFlosGelander1,
    description: 'Geländer, Treppen, Leitern und Gitteroste für die ARA Flos – montagefertige Stahlbauplanung mit präzisen Detailzeichnungen.',
    details: 'Typ: Stahlbau | Leistung: Fertigungs- und Montagepläne',
    gallery: [araFlosGelander1, araFlosGelander2, araFlosStege1, araFlosStege2, araFlosGitter1, araFlosGitter2]
  },
  {
    id: 2,
    title: 'ARA REINACH – ROHRLEITUNGSPLANUNG 3D',
    location: 'Reinach, Schweiz',
    type: 'Rohrleitungsplanung',
    mainImage: araReinach1,
    description: '3D-Rohrleitungsplanung und Isometrien für die ARA Reinach – kollisionsfreie Planung für Industrie und Anlagenbau.',
    details: 'Typ: Rohrleitungsplanung | Leistung: 3D-Planung, Isometrien',
    gallery: [araReinach1, araReinach2, araReinach3, araReinach4, araReinach5, araReinach6]
  },
  {
    id: 3,
    title: 'AUSSENTREPPE GLARNERLAND',
    location: 'Glarnerland, Schweiz',
    type: 'Stahlbau',
    mainImage: glarnerland1,
    description: 'Planung einer Aussentreppe in Stahl – von der Konzeptplanung bis zu montagefertigen Werkstattplänen.',
    details: 'Typ: Stahlbau | Leistung: Ausführungsplanung',
    gallery: [glarnerland1, glarnerland2]
  },
  {
    id: 4,
    title: 'BALKON GOLDACH',
    location: 'Goldach, Schweiz',
    type: 'Metallbau',
    mainImage: goldach1,
    description: 'Balkonkonstruktion in Stahl – detaillierte Fertigungszeichnungen und Montagepläne für den Metallbauer.',
    details: 'Typ: Metallbau | Leistung: Fertigungs- und Montagepläne',
    gallery: [goldach1, goldach2, goldach3]
  },
  {
    id: 5,
    title: 'STAHLBAU BASEL – PHASE 1',
    location: 'Basel, Schweiz',
    type: 'Stahlbau',
    mainImage: baselPhase1,
    description: 'Umfangreiche Stahlbauplanung für ein Grossprojekt in Basel – Konzept- und Ausführungsplanung in 2D und 3D.',
    details: 'Typ: Stahlbau | Leistung: Konzept- und Ausführungsplanung',
    gallery: [baselPhase1, baselPhase2, baselPhase3, baselPhase4, baselPhase5]
  },
  {
    id: 6,
    title: 'BASEL UESS',
    location: 'Basel, Schweiz',
    type: 'Stahlbau',
    mainImage: baselUess1,
    description: 'Stahlbaukonstruktionen für den Überlaufkanal – präzise CAD-Planung für die Fertigung.',
    details: 'Typ: Stahlbau | Leistung: Fertigungsplanung',
    gallery: [baselUess1, baselUess2]
  },
  {
    id: 7,
    title: 'BRAUCHWASSERPUMPWERK BASEL',
    location: 'Basel, Schweiz',
    type: 'Rohrleitungsplanung',
    mainImage: brauchwasser1,
    description: 'Rohrleitungsplanung für das Brauchwasserpumpwerk Basel – abgestimmt auf Architektur, Technik und Betrieb.',
    details: 'Typ: Rohrleitungsplanung | Leistung: Ausführungsplanung',
    gallery: [brauchwasser1, brauchwasser2]
  },
  {
    id: 8,
    title: 'EDELSTAHLWANNE GLATTBRUGG',
    location: 'Glattbrugg, Schweiz',
    type: 'Metallbau',
    mainImage: glattbrug1,
    description: 'Detaillierte Fertigungsplanung einer Edelstahlwanne – massgerechte CAD-Zeichnungen für die Produktion.',
    details: 'Typ: Metallbau | Leistung: Fertigungszeichnungen',
    gallery: [glattbrug1, glattbrug2, glattbrug3]
  },
  {
    id: 9,
    title: 'HANDWASCHTROG',
    location: 'Schweiz',
    type: 'Metallbau',
    mainImage: handwasch1,
    description: 'Konstruktionsplanung eines Handwaschtroges in Edelstahl – produktionsreife Zeichnungen.',
    details: 'Typ: Metallbau | Leistung: Fertigungszeichnungen',
    gallery: [handwasch1, handwasch2, handwasch3]
  },
  {
    id: 10,
    title: 'IPSACH KONSTRUKTION',
    location: 'Ipsach, Schweiz',
    type: 'Stahlbau',
    mainImage: ipsach1,
    description: 'Stahlbaukonstruktion Ipsach – detaillierte Werkstatt- und Montagepläne.',
    details: 'Typ: Stahlbau | Leistung: Ausführungsplanung',
    gallery: [ipsach1, ipsach2, ipsach3]
  },
  {
    id: 11,
    title: 'ROHRLEITUNGS-ISOMETRIE',
    location: 'Schweiz',
    type: 'Rohrleitungsplanung',
    mainImage: isometrie1,
    description: 'Erstellung von Rohrleitungs-Isometrien für die Produktion und Montage.',
    details: 'Typ: Rohrleitungsplanung | Leistung: Isometrien',
    gallery: [isometrie1]
  },
  {
    id: 12,
    title: 'LIFTKABINE',
    location: 'Schweiz',
    type: 'Metallbau',
    mainImage: liftkabine1,
    description: 'Komplette Konstruktionsplanung einer Liftkabine – 3D-Modell und detaillierte Fertigungszeichnungen.',
    details: 'Typ: Metallbau | Leistung: 3D-Modellierung, Fertigungspläne',
    gallery: [liftkabine1, liftkabine2, liftkabine3, liftkabine4]
  },
  {
    id: 13,
    title: 'PODEST LUGANO',
    location: 'Lugano, Schweiz',
    type: 'Stahlbau',
    mainImage: luganoPodest1,
    description: 'Podestanlage in Stahl für ein Industrieobjekt in Lugano – Fertigungs- und Montagepläne.',
    details: 'Typ: Stahlbau | Leistung: Fertigungs- und Montagepläne',
    gallery: [luganoPodest1, luganoPodest2, luganoPodest3]
  },
  {
    id: 14,
    title: 'ROHRLEITUNGSPLANUNG LUGANO',
    location: 'Lugano, Schweiz',
    type: 'Rohrleitungsplanung',
    mainImage: luganoRohr1,
    description: 'Rohrleitungsplanung für ein Industrie-Projekt in Lugano.',
    details: 'Typ: Rohrleitungsplanung | Leistung: Ausführungsplanung',
    gallery: [luganoRohr1, luganoRohr2]
  },
  {
    id: 15,
    title: 'PODEST MÄRSTETTEN',
    location: 'Märstetten, Schweiz',
    type: 'Stahlbau',
    mainImage: marstetten1,
    description: 'Fertigungsplanung eines Stahlpodestes – montagefertiges 3D-Modell.',
    details: 'Typ: Stahlbau | Leistung: 3D-Modellierung',
    gallery: [marstetten1]
  },
  {
    id: 16,
    title: 'STAHLBAU MÖHLIN',
    location: 'Möhlin, Schweiz',
    type: 'Stahlbau',
    mainImage: mohlinCad1,
    description: 'Umfangreiche Stahlbauplanung für ein Projekt in Möhlin – 2D- und 3D-Pläne mit Stücklisten.',
    details: 'Typ: Stahlbau | Leistung: Konzept- und Ausführungsplanung',
    gallery: [mohlinCad1, mohlinCad2, mohlinCad3, mohlinCad4, mohlinCad5, mohlinCad6, mohlinCad7, mohlinCad8, mohlinCad9, mohlinCad10]
  },
  {
    id: 17,
    title: 'ROHRLEITUNGSPLANUNG NIEDERGLATT',
    location: 'Niederglatt, Schweiz',
    type: 'Rohrleitungsplanung',
    mainImage: niederglatt1,
    description: 'Rohrleitungsplanung für ein Industrieobjekt in Niederglatt.',
    details: 'Typ: Rohrleitungsplanung | Leistung: Ausführungsplanung',
    gallery: [niederglatt1, niederglatt2]
  },
  {
    id: 18,
    title: 'PATIENTENSCHRANK',
    location: 'Schweiz',
    type: 'Metallbau',
    mainImage: patient1,
    description: 'Detaillierte Konstruktionsplanung eines Patientenschrankes in Edelstahl.',
    details: 'Typ: Metallbau | Leistung: Fertigungszeichnungen',
    gallery: [patient1, patient2]
  },
  {
    id: 19,
    title: 'PODEST AADORF',
    location: 'Aadorf, Schweiz',
    type: 'Stahlbau',
    mainImage: aadorf1,
    description: 'Montagefertiges 3D-Modell einer Industriepodestanlage.',
    details: 'Typ: Stahlbau | Leistung: 3D-Modellierung',
    gallery: [aadorf1]
  },
  {
    id: 20,
    title: 'PODEST RAPPERSWIL-JONA',
    location: 'Rapperswil-Jona, Schweiz',
    type: 'Stahlbau',
    mainImage: rapJona1,
    description: 'Stahlpodest mit 3D-Modellierung und 2D-Werkstattplänen – Planung bis Montagebegleitung.',
    details: 'Typ: Stahlbau | Leistung: 3D-Modell, Werkstattpläne',
    gallery: [rapJona1, rapJona2, rapJona3, rapSchnecke1, rapSchnecke2]
  },
  {
    id: 21,
    title: 'ROHRLEITUNGSPLANUNG WERDHÖLZLI',
    location: 'Zürich, Schweiz',
    type: 'Rohrleitungsplanung',
    mainImage: rohrWerd1,
    description: '3D-Rohrleitungsplanung für das Klärwerk Werdhölzli in Zürich.',
    details: 'Typ: Rohrleitungsplanung | Leistung: 3D-Planung',
    gallery: [rohrWerd1, rohrWerd2, rohrWerd3]
  },
  {
    id: 22,
    title: 'RUNDE KUNSTGELÄNDER',
    location: 'Schweiz',
    type: 'Metallbau',
    mainImage: kunstgelander4,
    description: 'Individuelles rundes Kunstgeländer – 3D-Modell und Fertigungszeichnungen für eine anspruchsvolle Formgebung.',
    details: 'Typ: Metallbau | Leistung: 3D-Modell, Fertigungspläne',
    gallery: [kunstgelander4, kunstgelander1, kunstgelander2, kunstgelander3]
  },
  {
    id: 23,
    title: 'SAUGKANAL',
    location: 'Schweiz',
    type: 'Stahlbau',
    mainImage: saugkanal1,
    description: 'Konstruktionsplanung eines Saugkanals – detaillierte Werkstattpläne.',
    details: 'Typ: Stahlbau | Leistung: Fertigungsplanung',
    gallery: [saugkanal1, saugkanal2, saugkanal3]
  },
  {
    id: 24,
    title: 'SCHÖNAU – PODESTE & TREPPEN',
    location: 'Schönau, Schweiz',
    type: 'Stahlbau',
    mainImage: schanauPodest1,
    description: 'Podeste, Treppen und Abkantbleche für das Projekt Schönau – umfassende Stahlbauplanung.',
    details: 'Typ: Stahlbau | Leistung: Konzept- und Ausführungsplanung',
    gallery: [
      schanauPodest1, schanauPodest2, schanauPodest3,
      schonauPumpe1, schonauPumpe2, schonauPumpe3, schonauPumpe4, schonauPumpe5,
      schonauTreppeAb1, schonauTreppeAb2,
      schonauTreppeAuf1, schonauTreppeAuf2, schonauTreppeAuf3
    ]
  },
  {
    id: 25,
    title: 'STAKETENGELÄNDER LANGNAU',
    location: 'Langnau, Schweiz',
    type: 'Metallbau',
    mainImage: langnau1,
    description: 'Staketengeländer in Stahl – Fertigungszeichnungen und Stücklisten für den Metallbauer.',
    details: 'Typ: Metallbau | Leistung: Fertigungszeichnungen',
    gallery: [langnau1, langnau2, langnau3, langnau4]
  },
  {
    id: 26,
    title: 'VORDACH AMRISWIL',
    location: 'Amriswil, Schweiz',
    type: 'Metallbau',
    mainImage: vordach1,
    description: 'Vordachkonstruktion in Stahl – Detailplanung und Fertigungszeichnungen.',
    details: 'Typ: Metallbau | Leistung: Fertigungspläne',
    gallery: [vordach1, vordach2]
  },
  {
    id: 27,
    title: 'WERDHÖLZLI – EBENE 1-2-3',
    location: 'Zürich, Schweiz',
    type: 'Stahlbau',
    mainImage: werdEbene1,
    description: 'Stahlbauplanung für mehrere Ebenen im Klärwerk Werdhölzli – Podeste, Geländer und Tragkonstruktionen.',
    details: 'Typ: Stahlbau | Leistung: Ausführungsplanung',
    gallery: [werdEbene1, werdEbene2, werdEbene3, werdEbene4, werdEbene5, werdEbene6]
  },
  {
    id: 28,
    title: 'WERDHÖLZLI – GELÄNDER & PODEST SCHAUMFALLE',
    location: 'Zürich, Schweiz',
    type: 'Stahlbau',
    mainImage: werdSchaum1,
    description: 'Geländer und Podest für die Schaumfalle im Klärwerk Werdhölzli.',
    details: 'Typ: Stahlbau | Leistung: Fertigungs- und Montagepläne',
    gallery: [werdSchaum1, werdSchaum2, werdSchaum3]
  },
  {
    id: 29,
    title: 'WERDHÖLZLI – RUNDER PODEST',
    location: 'Zürich, Schweiz',
    type: 'Stahlbau',
    mainImage: werdRund1,
    description: 'Runder Stahlpodest für das Klärwerk Werdhölzli – 3D-Modell und Montagepläne.',
    details: 'Typ: Stahlbau | Leistung: 3D-Modell, Montagepläne',
    gallery: [werdRund1, werdRund2, werdRund3, werdRund4]
  },
  {
    id: 30,
    title: 'WERDHÖLZLI – TREPPE AN BESTEHENDEM STEG',
    location: 'Zürich, Schweiz',
    type: 'Stahlbau',
    mainImage: werdTreppe1,
    description: 'Treppenanlage an bestehendem Steg – montagefertige Planung mit Bestandsaufnahme.',
    details: 'Typ: Stahlbau | Leistung: Fertigungs- und Montagepläne',
    gallery: [werdTreppe1, werdTreppe2, werdTreppe3]
  },
  {
    id: 31,
    title: 'BAUSTELLE – REALISIERTE PROJEKTE',
    location: 'Diverse Standorte, Schweiz',
    type: 'Stahlbau',
    mainImage: baustelle1,
    description: 'Impressionen von realisierten Stahlbauprojekten auf der Baustelle.',
    details: 'Typ: Stahlbau | Realisierte Projekte',
    gallery: [baustelle1, baustelle3, baustelle4, baustelle5, baustelle6]
  }
];
